import React from "react";

export default function StatementPrintStyles() {
  return (
    <style>{`
      @media print {
        @page {
          size: auto;
          margin: 12mm 15mm;
        }

        html, body {
          margin: 0 !important;
          padding: 0 !important;
          height: auto !important;
          min-height: 0 !important;
          background: #ffffff !important;
          overflow: visible !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        body * {
          visibility: hidden;
        }

        .statement-print-wrapper,
        .statement-print-wrapper * {
          visibility: visible;
        }

        .statement-print-wrapper a {
          color: #2563eb !important;
          text-decoration: underline !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .statement-print-wrapper {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          display: block !important;
          background: #ffffff !important;
          overflow: visible !important;
          height: auto !important;
          min-height: 0 !important;
          z-index: 999999 !important;
        }

        .statement-modal-content {
          position: static !important;
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
          max-height: none !important;
          box-shadow: none !important;
          border: none !important;
          border-radius: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
          background: #ffffff !important;
          overflow: visible !important;
        }

        .statement-scrollable-body {
          display: block !important;
          overflow: visible !important;
          height: auto !important;
          max-height: none !important;
          padding: 0 !important;
          margin: 0 !important;
        }

        .no-print,
        .no-print * {
          display: none !important;
          height: 0 !important;
          width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          visibility: hidden !important;
          overflow: hidden !important;
        }

        .print-only {
          display: table-cell !important;
        }

        .statement-summary-grid {
          display: flex !important;
          flex-direction: row !important;
          gap: 12px !important;
          margin-top: 14px !important;
          margin-bottom: 18px !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        .statement-summary-grid > div {
          flex: 1 1 0px !important;
          padding: 10px 12px !important;
        }

        .statement-group-card {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin-bottom: 16px !important;
          border: 1px solid #cbd5e1 !important;
        }

        table {
          width: 100% !important;
          border-collapse: collapse !important;
          page-break-inside: auto !important;
        }

        thead {
          display: table-header-group !important;
        }

        tr {
          page-break-inside: avoid !important;
          page-break-after: auto !important;
        }
      }
    `}</style>
  );
}
